// extracted by mini-css-extract-plugin
export default {"tooltip-action":"tooltip-action-T6SZi"};